import {
  Box,
  Flex,
  Text,
  useDisclosure,
  useTheme,
  Image,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import StatusConfirmationModal from "../../components/StatusConfirmModal";

const UserDetails = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const axios = getAxios();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [adIdToBlock, setAdIdToBlock] = React.useState<any>();
  const [blockStatus, setBlockStatus] = React.useState<any>();
  const access_token = Cookies.get("x-admin-auth");

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const blockOrUnblockUser = async (status: any) => {
    const result = status ? "unblock" : "block";
    try {
      const res = await axios.get(`/riders/${adIdToBlock}/${result}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("result", res.data);
      getUserDetails();
    } catch (error) {
      console.log(error);
    }
  };

  const [userFetchName, setUserFetchName] = React.useState<string>("initial");
  const [user, setUser] = React.useState<any>();
  const [ratings, setRatings] = React.useState<any>();
  const [ratingAll, setRatingAll] = React.useState<any>();

  const getUserDetails = async () => {
    try {
      const res = await axios.get(`/riders/${id}`);
      setUser(res.data);
    } catch (error) {
      console.log("error fetching users", error);
    }
  };

  const getUserRatings = async () => {
    try {
      const res = await axios.get(`/ratings/riders/${id}`);
      const totalRating = Number(res.data?.total_rating) || 0;
      const ratingCount = Number(res.data?.rating_count) || 0;
      const ratings = ratingCount > 0 ? totalRating / ratingCount : 0;
      setRatings(ratings);
    } catch (error) {
      console.log("error fetching ratings", error);
    }
  };

  const getUserRatingsAll = async () => {
    try {
      const res = await axios.get(`/ratings/riders/${id}/all`);
      console.log("all ratings", res.data);
      setRatingAll(res.data);
    } catch (error) {
      console.log("error fetching ratings all", error);
    }
  };

  React.useEffect(() => {
    if (id) {
      getUserDetails();
      getUserRatings();
      getUserRatingsAll();
    }
  }, [id, userFetchName]);

  return (
    <Box sx={{ padding: "1rem" }}>
      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        style={{
          width: "100%",
          margin: "1rem auto",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: "10px",
        }}
      >
        <Flex
          sx={{
            borderBottom: "1px solid",
            borderColor: theme.colors.divider,
            padding: "0.75rem 1.25rem",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
            User Details
          </Text>
          <Flex sx={{ gap: "1.5rem" }}>
            {user && (
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                  cursor: "pointer",
                }}
                onClick={() => {
                  onOpen();
                  setAdIdToBlock(id);
                  setBlockStatus(user?.is_blocked);
                }}
              >
                {user?.is_blocked ? "Unblock User" : "Block User"}
              </Text>
            )}
          </Flex>
        </Flex>
        <Flex
          sx={{
            padding: "1.25rem",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>Name:</Text>
              <Text sx={{ fontWeight: 600 }}>{user?.name}</Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Phone Number:
              </Text>
              <Text sx={{ fontWeight: 600 }}>{user?.mobile}</Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Joining Date:
              </Text>
              <Text sx={{ fontWeight: 600 }}>
                {(user &&
                  new Date(user.created_at).toLocaleDateString("en-IN")) ||
                  "   --"}
              </Text>
            </Flex>
            <Flex sx={{ gap: "0.5rem" }}>
              <Text sx={{ color: theme.colors.secondary.light }}>
                Account Status:
              </Text>
              <Text
                sx={{
                  fontWeight: 600,
                  color: user?.is_blocked
                    ? theme.colors.warning
                    : theme.colors.success,
                }}
              >
                {user?.is_blocked ? "Blocked" : "Active"}
              </Text>
            </Flex>
          </Box>
        </Flex>
      </Box>

      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        style={{
          width: "100%",
          margin: "2rem auto",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: "10px",
        }}
      >
        <Flex
          sx={{
            borderBottom: "1px solid",
            borderColor: theme.colors.divider,
            padding: "0.75rem 1.25rem",
            alignItems: "center",
            // justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
            User Ratings and Comments
          </Text>
          <Flex alignItems={"center"} justifyContent={"center"}>
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              {ratings?.toFixed(1) || 0.0}
            </Text>
            <Image
              src={"/StarFilled.png"}
              alt="No Images"
              aspectRatio={1 / 1}
              width="1.5rem"
            />
          </Flex>
        </Flex>
        <Box
          sx={{
            padding: "1.25rem",
          }}
        >
          {/* <Flex sx={{ gap: "0.5rem" }}>
            <Text sx={{ color: theme.colors.secondary.light }}>
              User Ratings:
            </Text>
            <Flex alignItems={"center"} justifyContent={"center"}>
              <Text sx={{ fontWeight: 600 }}>{ratings?.toFixed(1) || 0.0}</Text>
              <Image
                src={"/StarFilled.png"}
                alt="No Images"
                aspectRatio={1 / 1}
                width="1.2rem"
              />
            </Flex>
          </Flex> */}
          <Text
            sx={{ color: theme.colors.secondary.light, marginBottom: "0.5rem" }}
          >
            Showing 90 days ratings and comments
          </Text>
          {ratingAll &&
            ratingAll?.map((item: any, index: number) => {
              return (
                <Box
                  sx={{
                    gap: "0.5rem",
                    border: "1px solid",
                    borderColor: theme.colors.divider,
                    marginBottom: "1rem",
                    padding: "1rem",
                    borderRadius: "0.5rem",
                  }}
                  key={index}
                >
                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      Ratings:
                    </Text>
                    <Flex alignItems={"center"} justifyContent={"center"}>
                      <Text sx={{ fontWeight: 600 }}>
                        {item?.rating || 0.0}
                      </Text>
                      <Image
                        src={"/StarFilled.png"}
                        alt="No Images"
                        aspectRatio={1 / 1}
                        width="1.3rem"
                      />
                    </Flex>
                  </Flex>

                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      Comments:
                    </Text>
                    <Text sx={{ fontWeight: 600 }}>
                      {item?.comment || "-----------"}
                    </Text>
                  </Flex>
                  {/* <Text sx={{ color: theme.colors.secondary.light }}>
                    Comments: {item?.comment || "----"}
                  </Text> */}
                </Box>
              );
            })}
        </Box>
      </Box>

      <StatusConfirmationModal
        heading={`Are you sure want to ${blockStatus ? "unblock" : "block"} ?`}
        isOpen={isOpen}
        onClose={onClose}
        handleApiCall={() =>
          blockStatus ? blockOrUnblockUser(true) : blockOrUnblockUser(false)
        }
      ></StatusConfirmationModal>
    </Box>
  );
};

export default UserDetails;
